var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      ref: "chart",
      staticClass: "gantt-elastic__grid-lines-wrapper",
      style: { ..._vm.root.style["grid-lines-wrapper"] },
      attrs: {
        x: "0",
        y: "0",
        width: _vm.root.state.options.width,
        height: _vm.root.state.options.allVisibleTasksHeight,
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c(
        "g",
        {
          staticClass: "gantt-elastic__grid-lines",
          style: { ..._vm.root.style["grid-lines"] },
        },
        [
          _vm._l(_vm.horizontalLines, function (line) {
            return _c("line", {
              key: line.key,
              staticClass: "gantt-elastic__grid-line-horizontal",
              style: { ..._vm.root.style["grid-line-horizontal"] },
              attrs: { x1: line.x1, y1: line.y1, x2: line.x2, y2: line.y2 },
            })
          }),
          _vm._v(" "),
          _vm._l(_vm.verticalLines, function (line) {
            return _c("line", {
              key: line.key,
              staticClass: "gantt-elastic__grid-line-vertical",
              style: { ..._vm.root.style["grid-line-vertical"] },
              attrs: { x1: line.x1, y1: line.y1, x2: line.x2, y2: line.y2 },
            })
          }),
          _vm._v(" "),
          _c("line", {
            staticClass: "gantt-elastic__grid-line-time",
            style: { ..._vm.root.style["grid-line-time"] },
            attrs: {
              x1: _vm.timeLinePosition.x,
              y1: _vm.timeLinePosition.y1,
              x2: _vm.timeLinePosition.x,
              y2: _vm.timeLinePosition.y2,
            },
          }),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }